// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__V4EDa","content":"LoadingAlert_content__2RklD"};